<script>
import Vue from 'vue'
import UserService from '../../services/user'
import Store from '../../services/lstorage'
import BoardVisor from './boardVisor'
import BoardVisorSmall from './boardVisorSmall'
import UploadFiles from './uploadFiles'
import BodyMen from './bodyMen'
import Jquery from 'jquery'
import toast from 'vue-material-components'
// import UserInvites from '../home/invites'
import config from '../../../server/config.js'
import PersonalData from '../user/account/personalData'

// var intervalTorneos1 = null
// var intervalTorneos2 = null
// var userClub = []
var stylesBoard = {
  board: ['maple', 'brownboard', 'marble', 'blueboard', 'greenboard', 'wood'],
  pieces: ['fantasy', 'pirouetti', 'merida', 'cburnett', 'alpha', 'uscf', 'leipzig', 'spatial', 'maestro', 'horsey', 'anarcandy']
}

export default {
  route: {
    canActivate: function (transition) {
      return UserService.user_acces('authenticate') ? true : transition.redirect('user/loguin')
    }
  },
  template: require('./template.html'),
  data () {
    return {
      userSelected: null,
      finduser: '',
      sendToAll: false,
      dirActionUpload: Store.get('serverDir') + '/chat/upload',
      dirServer: Store.get('serverDir'),
      hashFileBoard1: '',
      hashFileBoard2: '',
      hashFileBoard3: '',
      fileProgress: 0,
      filesUpload: [],
      allFilesUploaded: true,
      offcanvas: false,
      active: 'boardVisor',
      activeChat: 'Chat',
      // mensjGame: [],
      tab: '0',
      tabs: [],
      chattext: '',
      user: UserService.user,
      boards: [],
      boardFiles: [],
      boardFilesName: '',
      boardFiles2: [],
      boardFilesName2: '',
      boardFiles3: [],
      boardFilesName3: '',
      newboard: {
        color: 'w',
        time: '3',
        incremento: 0,
        elo: 1500,
        contrincante: '',
        public: 'true',
        broadcast: 'false',
        all: 'false',
        club: UserService.user.club
      },
      users: [],
      usersLength: 0,
      games: [],
      boardHome: Store.get('boardSee', {}),
      stylesBoard: stylesBoard,
      styles: Store.get('styleBoard',
        {
          board: 0,
          pieces: 0
        }),
      classBoard: '',
      sendtoteacher: false
      // userClubData: {}
    }
  },
  mixins: [
    toast
    // UserInvites
  ],
  events: {
    updatepermissions (dta) {
      // window.alert(JSON.stringify(dta))
      this.user.chat = dta.men.user.chat
      this.user.chattext = dta.men.user.chattext
      this.user.chataudio = dta.men.user.chataudio
      this.user.cast = dta.men.user.cast
      this.user.live = dta.men.user.live
      this.user.analyse = dta.men.user.analyse
      this.user.sendtoanalyse = dta.men.user.sendtoanalyse
      this.user.download = dta.men.user.download
      if (this.user.username === dta.men.user.username) {
      }
      console.log('EVENT updatepermissions ')
    },
    mensendactivate (data) {
      // -- Cambiar un permiso
      // UserService.setUser(this.user)
      /* if (data.men.user.nickname === this.user.username) {
        this.user.sendtoanalyse = data.men.user.sendtoanalyse
        // window.alert(data.men.user.nickname.sendtoanalyse)
      }*/
      var usermen = data.men.user.username
      var username = this.user.username
      if (usermen === username) {
        // window.alert(username + '->' + data.men.user.sendtoanalyse)
        this.user.sendtoanalyse = data.men.user.sendtoanalyse
        this.sendtoteacher = data.men.user.sendtoanalyse
        var _self = this
        this.loadOtherUser(this.user.username, function (someUser) {
          // window.alert(someUser.sendtoanalyse)
          _self.sendtoteacher = someUser.sendtoanalyse
        })
      }
      // --
      // }
      console.log('EVENT mensendactivate ')
    },
    users (data) {
      this.users = data.nicknames
      console.log('EVENT users ')
    },
    boards (data) {
      // this.loadUserClubData(data.boards)
      this.boards = data.boards
      console.log('EVENT boards ')
      // window.alert('update boards')
    },
    /* userClubData (data) {
      this.userClubData = data.userClubData
    },*/
    mensaje (data) {
      if (data.send !== this.user.username) {
        this.recibeMensaje(data.men, true, true)
      }
      // window.alert(JSON.stringify(data.men))
    },
    onFileClick (file) {
      // console.log('onFileClick', file)
    },
    onFileChange (file) {
      // console.log('onFileChange', file)
      // here is where we update our view
      this.fileProgress = 0
      this.allFilesUploaded = false
    },
    beforeFileUpload (file) {
      // called when the upload handler is called
      // console.log('beforeFileUpload', file)
      this.toast('<span>' + 'Cargando imagen' + '</span>', 2000)
    },
    afterFileUpload (file) {
      // called after the xhr.send() at the end of the upload handler
      // console.log('afterFileUpload', file)
      this.toast('<span>' + Vue.t('home.uploadMens.success') + '</span>', 2000)
    },
    onFileProgress (progress) {
      // console.log('onFileProgress', progress)
      // update our progress bar
      this.fileProgress = parseInt(progress.percent)
    },
    onFileUpload (file, res) {
      // console.log('onFileUpload', file, res)
      this.chattext = {
        name: file.name,
        size: file.size,
        type: file.type,
        lastModifiedDate: file.lastModifiedDate
      }
      this.sendMensaje('file')
    },
    onFileError (file, res) {
      this.toast('<span>Error ' + res + '</span>', 3000)
      // console.error('onFileError', file, res)
    },
    onAllFilesUploaded (files) {
      // console.log('onAllFilesUploaded', files)
      this.toast('<span>' + Vue.t('home.uploadMens.success') + '</span>', 2000)
      // everything is done!
      this.allFilesUploaded = true
    },
    updateBoards (classBoard) {
      this.classBoard = classBoard
      console.log('EVENT updateBoards ')
    }
  },
  props: {},
  computed: {
    userClub () {
      return this.$root.userClub || {}
    }
  },
  components: {
    BoardVisor,
    UploadFiles,
    BodyMen,
    BoardVisorSmall,
    PersonalData
  },
  watch: {
    inmediate: true,
    newEmoji (newVal, oldVal) {
      this.chattext += newVal
      document.getElementById('textChatInput').focus()
    }
  },
  methods: {
    getLength (param) {
      var ret = 0
      if (param !== undefined && Object.keys(param) !== undefined) {
        ret = Object.keys(param).length
      }
      return ret
    },
    imageUrlAlt (event) {
      // window.alert(this.user.sexo)
      event.target.src = '../../../static/images/50x50defaultAvatar.png'
    },
    imageUrl (name) {
      var ret = ''
      if (name !== undefined) {
        ret = this.dirServer + '/uploads/' + name
      }
      return ret
    },
    userScroll (e) {
      var scrollTop = e.target.scrollTop
      // var scrollWidth = e.target.scrollWidth
      // var scrollHeight = e.target.scrollHeight
      // var clientHeight = e.target.clientHeight
      // console.log(scrollTop, scrollWidth, scrollHeight, clientHeight)
      if (scrollTop === 0) {
        var post = this.foundTab(this.active)
        // console.log('cargar historial anterior', this.active)
        var parmsLoad = {
          user: this.active,
          range: {
            limit: 20,
            skip: this.tabs[post].men.length
          }
        }
        this.loadUserConvert(parmsLoad, true)
      }
    },
    createGame () {
      this.$broadcast('modal::open', 'invitePCAnalisis')
    },
    userToConversationWhite (user) {
      this.activeWhite = user
      this.active = user.nickname
      // window.alert(this.active)
      this.$broadcast('modal::close', 'some', 'usersConnectWhite')
      this.$broadcast('modal::open', 'inviteGameVersus')
    },
    userToConversationBlack (user) {
      this.userconvert = user
      this.newboard.contrincante = user.nickname
      this.$broadcast('modal::close', 'some', 'usersConnectBlack')
      this.$broadcast('modal::open', 'inviteGameVersus')
    },
    sendReto () {
      if (this.$parent && this.$parent.userClub && this.$parent.userClub.isTournament) {
        window.swal('No puedes enviar retos mientras estás en un torneo')
        return
      }
      this.active = this.user.username
      this.userconvert = this.user
      this.userconvert.nickname = '-ALL-'
      this.newboard.contrincante = '-ALL-'
      this.$broadcast('modal::open', 'inviteGameFast')
    },
    userToConversationComputer (name) {
      // this.inviteChessGameDirectComputer(name)
      this.userconvert = this.user
      this.userconvert.nickname = name
      this.newboard.contrincante = name
      this.$broadcast('modal::close', 'some', 'usersConnectBlack')
      this.$broadcast('modal::close', 'some', 'usersConnectWhite')
      this.$broadcast('modal::open', 'inviteGameVersus')
    },
    onClickUser (userSelected) {
      this.userSelected = userSelected
      // window.alert(JSON.stringify(this.user))
      this.$broadcast('modal::open', 'userInfo')
    },
    selectUserToConversationWhite () {
      const data = {
        c: 'chat',
        f: 'username',
        data: {
          user: this.user
        }
      }
      const showSocketError = (context = '') => {
        console.error('Socket desconectado error')
      }
      const maxRetries = 10
      const retryDelay = 500 // milisegundos
      let attempt = 1
      const tryEmit = () => {
        const socket = this.$socket

        if (socket && socket.connected) {
          socket.emit('event', data, (...callbacks) => {
            this.usersConnect = callbacks[1]
            this.$broadcast('modal::close', 'some', 'inviteGameVersus')
            this.$broadcast('modal::open', 'usersConnectWhite')
            console.log('USERLOGUINSOCKET:', callbacks[1])
          })
        } else {
          if (attempt <= maxRetries) {
            console.warn(`userLoguinSocket: intento ${attempt}/${maxRetries} - socket no conectado`)
            attempt++
            setTimeout(tryEmit, retryDelay)
          } else {
            showSocketError('userLoguinSocket: No se pudo conectar después de varios intentos')
          }
        }
      }

      tryEmit()
    },
    selectUserToConversationBlack () {
      const data = {
        c: 'chat',
        f: 'username',
        data: {
          user: this.user
        }
      }
      const showSocketError = (context = '') => {
        console.error('Socket desconectado error')
      }
      const maxRetries = 10
      const retryDelay = 500 // milisegundos
      let attempt = 1
      const tryEmit = () => {
        const socket = this.$socket

        if (socket && socket.connected) {
          socket.emit('event', data, (...callbacks) => {
            this.usersConnect = callbacks[1]
            this.$broadcast('modal::close', 'some', 'inviteGameVersus')
            this.$broadcast('modal::open', 'usersConnectBlack')
            console.log('USERLOGUINSOCKET:', callbacks[1])
          })
        } else {
          if (attempt <= maxRetries) {
            console.warn(`userLoguinSocket: intento ${attempt}/${maxRetries} - socket no conectado`)
            attempt++
            setTimeout(tryEmit, retryDelay)
          } else {
            showSocketError('userLoguinSocket: No se pudo conectar después de varios intentos')
          }
        }
      }

      tryEmit()
    },
    isAtBottom () {
      if (this.active === 'boardVisor') {
        return
      }
      var tabConvert = document.getElementById('content_' + this.active)
      if (tabConvert) {
        var atBottom = tabConvert.scrollTop >= tabConvert.scrollHeight - tabConvert.clientHeight
        if (atBottom) {
          this.scrollBottom()
        }
      }
    },
    scrollBottom () {
      if (Jquery('#content_' + this.active) !== undefined && Jquery('#content_' + this.active)[0] !== undefined) {
        Jquery('#content_' + this.active).animate({
          'scrollTop': Jquery('#content_' + this.active)[0].scrollHeight
        }, 'slow')
      }
    },
    toogleOfCanvas () {
      this.offcanvas = !this.offcanvas
    },
    parse_pgn_header (header) {
      var newlineChar = '\r?\n'
      var headerObj = {}
      // header = header.split('"]').join('"]\n')
      var headers = header.split(new RegExp(newlineChar))
      var key = ''
      var value = ''
      for (var i = 0; i < headers.length; i++) {
        key = headers[i].replace(/^\[([A-Z][A-Za-z]*)\s.*\]$/, '$1')
        value = headers[i].replace(/^\[[A-Za-z]+\s"(.*)"\]$/, '$1')
        if (key.length > 0 && value.length > 0 && key !== value) {
          headerObj[key] = value
        }
      }
      return headerObj
    },
    generateHeader (pgnFile, complete = true) {
      var retHeader = ''
      // var pgnInLines = pgnFile.split('"]').join('"]\n')
      var headers = this.parse_pgn_header(pgnFile)
      if (headers !== undefined && headers['Event'] !== undefined) {
        var appendHeader = function (result, headers, separator) {
          if (headers && headers.length > 0) {
            if (result.length > 0) {
              result += separator
            }
            result += headers
          }
          return result
        }
        var hh = [headers['Event'], headers['Site']] //, headers['Round'], headers['Date'], headers['ECO'], headers['Result']]
        if (complete) {
          retHeader = 'Blancas: ' + headers['White'] + ' Negras: ' + headers['Black']
          hh = [headers['Event'], headers['Site'], headers['Round'], headers['Date'], headers['ECO'], headers['Result']]
        }
        retHeader += ' ('
        var rest = ''
        hh.forEach(function (headers) {
          rest = appendHeader(rest, headers, ' | ')
        })
        retHeader += rest
        retHeader += ')'
        // window.alert(retHeader)
      }
      retHeader = decodeURIComponent(escape(retHeader))
      return retHeader
    },
    openTab (user, active = true) {
      if (user.nickname !== UserService.getUser().username) {
        // clearTimeout(window.computerGame)
        var tabConvert = {
          name: user.nickname,
          idTab: user.nickname,
          men: []
        }
        if (!this.foundTab(tabConvert.idTab)) {
          this.tabs.push(tabConvert)
          var parmsLoad = {
            user: tabConvert.idTab,
            range: {
              limit: 30,
              skip: 0
            }
          }
          this.loadUserConvert(parmsLoad)
        }
        if (active) {
          this.active = tabConvert.idTab
        }
        // this.tabs.select(tabConvert.idTab)
        // this.tabs.updateTabIndicator()
      }
    },
    foundTab (tab) {
      for (var i in this.tabs) {
        if (this.tabs[i].idTab === tab) {
          return i
        }
      }
      return false
    },
    closeTab (tab) {
      var post = this.foundTab(tab)
      this.tabs.splice(post, 1)
      if (this.tabs.length === 0) {
        this.active = 'boardVisor'
      } else {
        if (this.active === this.tabs[this.tabs.length - 1].idTab) {
          this.active = 'nnn'
        }
        setTimeout(function () {
          this.active = this.tabs[this.tabs.length - 1].idTab
        }.bind(this), 200)
      }
      var data = {
        c: 'chat',
        f: 'removeConversation',
        data: {
          user: UserService.getUser().username,
          conver: tab
        }
      }
      const showSocketError = (context = '') => {
        console.error('Socket desconectado error')
      }
      const maxRetries = 10
      const retryDelay = 500 // milisegundos
      let attempt = 1
      const tryEmit = () => {
        const socket = this.$socket

        if (socket && socket.connected) {
          socket.emit('event', data, (...callbacks) => {
            console.log('USERLOGUINSOCKET:', callbacks[1])
          })
        } else {
          if (attempt <= maxRetries) {
            console.warn(`userLoguinSocket: intento ${attempt}/${maxRetries} - socket no conectado`)
            attempt++
            setTimeout(tryEmit, retryDelay)
          } else {
            showSocketError('userLoguinSocket: No se pudo conectar después de varios intentos')
          }
        }
      }

      tryEmit()
    },
    loadOtherUser (otherUser, next) {
      if (otherUser !== 'PC' && otherUser !== undefined && otherUser.length > 0) {
        // window.alert(otherUser)
        UserService.get(this, otherUser).then(function (response) {
          const dd = JSON.parse(response)
          const somedata = dd
          next(somedata)
        }, function (response) {
        // window.alert('mal')
        })
      }
    },
    getUserClub (username) {
      this.loadOtherUser(username, function (someUser) {
        return someUser.club
      })
    },
    showBoard (board, open = false) {
      // window.alert(JSON.stringify(board) + ' ' + open)
      if (board === undefined || this.isBoardVisible(board) === false) {
        // window.alert(JSON.stringify(board) + ' ' + open)
        // board = {'urls': '', 'type': 'public', 'pgn': '[Event "Hoogovens"]\n\n[Site "Wijk aan Zee"]\n\n[Date "1999.01.20"]\n\n[Round "4"]\n\n[White "Kasparov, Gary"]\n\n[Black "Topalov, Veselin"]\n\n[Result "1-0"]\n\n[ECO "B07"]\n\n[WhiteElo "2812"]\n\n[BlackElo "2700"]\n\n[Annotator "Moreno Ruiz,J"]\n\n[PlyCount "87"]\n\n[EventDate "1999.??.??"]\n\n[EventType "team"]\n\n1. e4 d6 2. d4 Nf6 3. Nc3 g6 {la defensa Pirc, ha planteado el negro, arriesgada, como el estilo del GM Bulgaro, cede el centro y la iniciativa a las blancas,} 4. Be3 Bg7 5. Qd2 {El blanco plantea un esquema de ataque tipico contra un fianchetto: Cambiarlo con Ah6.} c6 6. f3 b5 {El negro intenta ganar espacio en el flanco de dama para contrarrestar el dominio central del blanco, aunque esto es una estrategia dudosa.} ( 6... O-O {Esto serÃ­a muy arriesgado para el negro, pues otorga al blanco un plan de ataque sobre el flanco de rey claro y directo.} 7. Bh6 Nbd7 8. h4$1 b5 9. h5$1$16 ) 7. Nge2 {Las blancas no quieren definir el enroque largo tan pronto, y hacen una jugada muy util, sin abandonar la posibilidad del enroque corto.} Nbd7 {El negro pretende llevar un Cc4.} 8. Bh6 {[#]El blanco cumple con una parte de su estrategia, consistente en cambiar el fuerte alfil negro.} Bxh6 ( 8... O-O 9. h4$1 {CederÃ­a un ataque peligroso al blanco, siguiendo con Ph5. Esto es un plan temÃ¡tico en muchas posiciones para atacar el enroque corto fianchettado del negro.} ) 9. Qxh6 Bb7 {Las negras preparan el enroque largo, donde el rey estarÃ¡ mas seguro.} 10. a3 {Una jugada de espera util.} ( 10. O-O-O {las negras podian continuar con} b4 {con la idea de Da5 y Cb6 planteando algunos problemas.} ) e5 11. O-O-O Qe7 {Preparando el enroque largo.} 12. Kb1$1 {El principio de un gran plan de Kasparov, dedicado a atacar tambien el enroque largo del blanco!} a6 13. Nc1 O-O-O 14. Nb3$1 {[#]Esta era la idea de Rb1! El caballo se incorpora en el ataque con Ca5, y el rey serÃ¡ perseguido en el flanco de dama.} exd4 15. Rxd4 c5 16. Rd1 Nb6 17. g3$1 {Incorporando el alfil en el ataque!} Kb8 18. Na5 Ba8 19. Bh3 d5$5 {[#] Topalov se resiste a un juego pasivo y abre el centro, Â¡pero ahora su rey expuesto otorga al blanco multitud de temas!} 20. Qf4+ Ka7 21. Rhe1 d4$5 22. Nd5$1 {Â¡Refutando toda la idea del negro! Una jugada pasiva de Kasparov hubiera dado al negro la iniciativa.} ( 22. Na2$6 Rhe8$11 ) Nbxd5 {La partida sera muy dificil de seguir si no voy exponiendo las distintas alternativas tacticas, por lo tanto de aqui en adelante deberemos acompanarnos de analisis de variantes para poder disfrutar, del ingenio y talento creador del " Ogro de Baku ".} ( 22... Bxd5$2 23. exd5 Qd6 24. Nc6+ Ka8 25. Re7 {Con posicion ganadora.} ) ( 22... Nfxd5$2 23. exd5 {Y la dama negra tiene un problema de sobrecarga ya que tiene que proteger, dos puntos, la entrada de la dama blanca por c7 y el peon de f7.} Qd6 24. Qxf7+ {Con ventaja ganadora, para el blanco.} ) 23. exd5 Qd6 24. Rxd4$3 {[#]En realidad hoy todavia es dificil evaluar perfectamente si es del todo correcta esta jugada pero desde el punto de vista artistico, humano es sin duda genial, especialmente cuando las blancas tenÃ­an a mano un final equilibrado con 24. Cc6.} ( 24. Nc6+ {Era la alternativa solida.} Bxc6 25. Qxd6 Rxd6 26. dxc6 Rxc6 27. Re7+ Kb6 28. Rxf7 Re8$11 ) cxd4$2 ( 24... Qxf4 25. Rxf4 Nxd5 26. Rxf7+ Kb6 27. Nb3 Bc6 {Con pequeÃ±a ventaja blanca} ) ( 24... Bxd5$5 {SerÃ­a muy interesante y compleja.} ) 25. Re7+$3 {Un mazazo sorprendente. Â¡Â¡La torre no puede capturarse!!} Kb6 ( 25... Qxe7$2 26. Qxd4+ Kb8 27. Qb6+ Bb7 28. Nc6+ Ka8 29. Qa7# ) 26. Qxd4+ Kxa5 {No hay mas remedio que emprender una arriesgada fuga del rey.} ( 26... Qc5 27. Qxf6+ Qd6 ( 27... Kxa5$4 28. b4+ ) 28. Rxf7 Qxf6 ( 28... Kxa5 29. Qc3+ b4 30. axb4+ Qxb4 31. Qc7+ Kb5 ( 31... Ka4 32. Rf4 ) ( 31... Qb6 32. b4+ Kb5 33. Bf1+ {ganando.} ) 32. Bf1+ Ka4 33. Rf4 {ganando.} ) 29. Rxf6+ Kc5 ( 29... Kxa5$4 30. b4+ Ka4 31. Rxa6# ) 30. Nb3+ Kxd5 31. Rxa6 {Con ventaja blanca.} ) 27. b4+ Ka4 28. Qc3 {amenazando Db3 mate.} Qxd5 29. Ra7$1 {[#]} Bb7 {Unica, ya que a} ( 29... Rd6 30. Kb2 {Amenazando Db3} Qd4 31. Qxd4 Rxd4 32. Rxa6# ) 30. Rxb7 Qc4$6 ( 30... Rhe8$5 31. Rb6 Ra8 32. Rxf6 {Con pequeÃ±a ventaja blanca.} Qc4 33. Qxc4 bxc4 34. Kb2 Re7 35. Rc6 Kb5 36. Rc5+ Kb6 37. Rxc4$14 ) 31. Qxf6 Kxa3 {Todo esto parece una fuga hacia delante, no habia alternativas ya que las blancas amenazaban el peon de a6.} ( 31... Rd1+ 32. Kb2 Qd4+ ( 32... Ra8 33. Qb6 Qd4+ 34. Qxd4 Rxd4 35. Rxf7 a5 36. Be6 axb4 37. Bb3+ Ka5 38. axb4+ Kb6 {No era posible capturar el peon a causa de c3.} 39. Rxh7 {Con final ganador.} ) 33. Qxd4 Rxd4 34. Rxf7 Rd6 35. Re7 Ra8 36. Be6 {Con posicion ganadora.} ) 32. Qxa6+ Kxb4 {[#] Parece que la audaz y arriesgada fuga de rey va a tener exito, pero...} 33. c3+$1 Kxc3 34. Qa1+$1 Kd2 {unica tambien.} ( 34... Kb4 35. Qb2+ Qb3 ( 35... Kc5 36. Rc7+ ) ( 35... Ka5 36. Qa3+ Qa4 37. Ra7+ Kb6 38. Rxa4 ) ( 35... Ka4 36. Ra7# ) 36. Rxb5+ ) 35. Qb2+ Kd1 {Momento critico!! El negro parece haberse salido con la suya, y ahora el rey negro colabora en el ataque. Â¡Incluso el rey blanco se ve amenazado de Dd3+!, pero hay un recurso inesperado que confirma todo el juego blanco hasta aquÃ­.} ( 35... Ke3 36. Re7+ Kxf3 37. Qg2# ) 36. Bf1$3 {[#]Curioso que despues de llevar el rey por todo el tablero la clave de la combinacion de entrega de torre en d4 de la jugada 24, este justo aqui doce jugadas mas adelante, y sin la cual nada de lo anterior se hubiera podido hacer.} Rd2 {La mejor defensa.} ( 36... Qxf1 37. Qc2+ Ke1 38. Re7+ Qe2 39. Qxe2# ) 37. Rd7$1 {Una clavada mortal!! Elegancia absoluta en esta jugada!!} Rxd7 38. Bxc4 bxc4 39. Qxh8$1 {Un detalle elegante y necesario. El negro todavÃ­a tiene cierta resistencia desesperada.} Rd3 40. Qa8 c3 41. Qa4+ Ke1 42. f4 f5 43. Kc1 Rd2 44. Qa7$1 {Otra elegante jugada larga de dama. El negro pierde ahora mas peones, con lo que Topalov abandona. Â¡UNA VERDADERA OBRA DE ARTE!  Segun una votaciÃ³n en una importante revista, la mejor partida del siglo XX.} ( 44. Qa7 h5 ( 44... Rxh2$2 45. Qg1+$18 ) 45. Qb6 h4 46. Qxg6$18 ) 1-0', '_id': '631c3f1e08dd9309e84142d7', 'u1': 'admin', 'u2': 'admin', 'public': 'true', 'all': 'false', 'club': 'General', 'name': 'PARTIDA DE EJEMPLO', 'lesson': '', 'category': '', 'time': '90', 'elo': '1500', 'incremento': '0', 'created': '2022-09-10T07:39:09.989Z', '__v":0,"motiv': 'closed', 'wins': 'black'}
        return
      }
      /* if ((board.u1 === this.user.username || board.u2 === this.user.username) || board.public === 'true' || board.all === 'true' &&
        (board.club === this.user.club || board.all === 'true')) {
      } else {
        return
      }*/
      /* if (board.all === 'false' && (board.club !== undefined && board.club !== this.user.club)) {
        // window.alert('Parece que no es de tu club')
        // this.toast('<span>Parece que no es de tu club</span>', 5000)
        return
      }*/

      var boardFound = board._id
      // var boardToStore = 'board1'
      var boardToStore = board._id
      // for (var i = 1; i <= 200; i++) {
      // if (!Store.get(boardToStore) || !Store.get(boardToStore)._id) {
      // break
      // } else {
      if (board._id === Store.get(boardToStore)._id) {
        boardFound = boardToStore
      }
      //     break
      //   }
      //  boardToStore = 'board' + i
      // }
      // }
      var headers = this.parse_pgn_header(board.pgn)
      if (headers['FEN'] !== undefined && headers['FEN'] !== null) {
        board.fen = headers['FEN']
        // window.alert(headers['FEN'])
      }
      if (open === true && board.u1 === board.u2 && this.user.username !== board.u1) {
        // Store.set(boardToStore, board)
        Store.set(board._id, board)
        boardFound = boardToStore
      }
      // window.alert(JSON.stringify(Store.get(boardFound)))
      if (open === true && boardFound !== '' && (this.user.username === board.u1 || this.user.username === board.u2 || (board.u2 === board.u1))) {
        Store.set(boardFound, board)
        // window.alert('/game/' + JSON.stringify(Store.get(boardFound)))
        this.$route.router.go('/game/' + boardFound)
      } else {
        // window.alert('boardHome' + JSON.stringify(board))
        this.boardHome = board
        Store.set('boardSee', board)
        // window.alert('boardSee')
        // console.log(this.active)
        this.active = 'boardVisor'
      }
    },
    desactiveBoard () {
      this.boardHome = {}
      setTimeout(function () {
        this.active = 'boardVisor'
      }.bind(this), 200)
    },
    sendMensaje (type = 'text') {
      if (type === 'text') {
        if (this.chattext.trim() === '') {
          this.chattext = ''
          return
        }
      }
      // window.alert(this.chattext)
      var post = this.foundTab(this.active)
      var men = {
        body: this.chattext,
        type: type,
        public: this.sendToAll,
        club: UserService.getUser().club,
        board: 'Individual', // this.boardHome._id,
        send: UserService.getUser().username,
        recibe: this.tabs[post].idTab
      }
      var data = {
        c: 'chat',
        f: 'mensaje',
        data: {
          men: men
        }
      }
      const showSocketError = (context = '') => {
        console.error('Socket desconectado error')
      }
      const maxRetries = 10
      const retryDelay = 500 // milisegundos
      let attempt = 1
      const tryEmit = () => {
        const socket = this.$socket

        if (socket && socket.connected) {
          socket.emit('event', data, (...callbacks) => {
            console.log('USERLOGUINSOCKET:', callbacks[1])
          })
        } else {
          if (attempt <= maxRetries) {
            console.warn(`userLoguinSocket: intento ${attempt}/${maxRetries} - socket no conectado`)
            attempt++
            setTimeout(tryEmit, retryDelay)
          } else {
            showSocketError('userLoguinSocket: No se pudo conectar después de varios intentos')
          }
        }
      }

      tryEmit()
      this.chattext = ''
    },
    recibeMensaje (men, bottom = false, toast = true) {
      if (men.board === 'Individual') {
        var tabUser = men.send === UserService.getUser().username ? men.recibe : men.send
        var post = this.foundTab(tabUser)
        if (post) {
          this.tabs[post].men.push(men)
        } else {
          var tabConvert = {
            name: tabUser,
            idTab: tabUser,
            men: [men]
          }
          if (UserService.getUser().username !== men.send) {
            this.tabs.push(tabConvert)
            var active = this.active
            setTimeout(function () {
              this.active = active
            }.bind(this), 200)
          }
        }
        // this.mensjGame.push(men)
        if (bottom) {
          this.isAtBottom()
        }
        if (toast === true) {
          if (men.send !== UserService.getUser().username) {
            this.toast('<span>' + men.send + ': ' + men.body + '</span>', 5000)
          }
        }
      }
    },
    isMine (board) {
      // window.alert(board.u1 + board.u2 + this.user.username)
      return this.user.username === board.u1 || this.user.username === board.u2
    },
    wellCome () {
      // window.alert('Bienvenido')
      window.swal('Bienvenido', {
        buttons: {
          si: {text: 'Aceptar', value: 'accept'}
        }
      }).then(function (resultParam) {
      })
    },
    /* parsePgnFiles (file, number) {
      var newlineChar = '\r?\n'
      var filesObj = {} // this.boardFiles
      file = file.replace(/\{( *)\}/gmu, '')
      file = file.replace(/\{\[%emt(\s\S.+?)\]\}/gmu, '')
      var lines = file.split(new RegExp(newlineChar))
      var pgntext = ''
      var state = 0 // 0 header, 1 moves
      var board = {}
      var headers = {}
      // var found = []
      var hashCode = ''
      var nIndex = 0
      for (var i = 0; i < lines.length; i++) {
        if (lines[i].length > 0) {
          if (lines[i].includes('[') && lines[i].includes('"') && lines[i].includes(']')) {
            if (state === 1) {
              headers = this.parse_pgn_header(pgntext)
              hashCode = this.hashCode(this.generateHeader(pgntext, true))
              board = { pgn: pgntext, _id: hashCode, type: 'torneo', u1: headers['White'], u2: headers['Black'], name: '' }
              if (headers['Result'] === '*') {
                nIndex = nIndex + 1
                filesObj[nIndex] = board
              }
              /* found = filesObj.find(element => element !== undefined && element._id === hashCode)
              if (found === undefined || found === null) {
                filesObj[i] = board
              } else {
                filesObj.forEach(function changePgnBoardFiles (item, index) {
                  if (item._id === hashCode) {
                    // window.alert(hashCode)
                    item.pgn = pgntext
                  }
                })
              }*
              pgntext = ''
            }
            state = 0
          } else {
            state = 1
          }
          if (state === 0) {
            pgntext += lines[i] + '\r\n'
          } else {
            pgntext += lines[i] + ' '
          }
        }
      }
      headers = this.parse_pgn_header(pgntext)
      hashCode = this.hashCode(this.generateHeader(pgntext, true))
      board = { pgn: pgntext, _id: hashCode, type: 'torneo', u1: headers['White'], u2: headers['Black'], name: '' }
      if (headers['Result'] === '*') {
        filesObj[nIndex] = board
      }
      // this.pgnFiles = filesObj
      // this.$broadcast('modal::open', 'pgnFiles')
      /* found = filesObj.find(element => element !== undefined && element._id === hashCode)
      if (found === undefined || found === null) {
        filesObj[i] = board
      } else {
        filesObj.forEach(function changePgnBoardFiles (item, index) {
          if (item._id === hashCode) {
            // window.alert(hashCode)
            item.pgn = pgntext
          }
        })
      }*
      if (number === 2) {
        this.boardFiles2 = filesObj
        this.boardFilesName2 = headers['Event'] + ' | ' + headers['Site']
      } else if (number === 3) {
        this.boardFiles3 = filesObj
        this.boardFilesName3 = headers['Event'] + ' | ' + headers['Site']
      } else {
        this.boardFiles = filesObj
        this.boardFilesName = headers['Event'] + ' | ' + headers['Site']
      }
      return filesObj
    },*/
    hashCode (s) {
      var h = 0
      var l = s.length
      var i = 0
      if (l > 0) {
        while (i < l) {
          h = (h << 5) - h + s.charCodeAt(i++) | 0
        }
      }
      var hexString = h.toString(16)
      return hexString
    },
    /* getTorneos (number) {
      var _self = this
      var oReq = new window.XMLHttpRequest()
      oReq.open('GET', '../../../static/torneos/live' + number + '.pgn', true) // ../../../static/live.pgn', true)
      // oReq.setRequestHeader('Access-Control-Allow-Origin', '*')
      oReq.onload = function () {
        var hashFile = _self.hashCode(this.responseText)
        if (number === 1 && _self.hashFileBoard1 !== hashFile) {
          _self.hashFileBoard1 = hashFile
          _self.parsePgnFiles(this.responseText, true, number)
          for (var i = 0; i < Object.keys(_self.boardFiles).length; i++) {
            if (_self.boardFiles[i] !== undefined && _self.boardFiles[i]._id === Store.get('boardSee')._id) {
              _self.showBoard(_self.boardFiles[i])
            }
          }
        } else if (number === 3 && _self.hashFileBoard3 !== hashFile) {
          _self.hashFileBoard3 = hashFile
          _self.parsePgnFiles(this.responseText, true, number)
          for (i = 0; i < Object.keys(_self.boardFiles3).length; i++) {
            if (_self.boardFiles3[i] !== undefined && _self.boardFiles3[i]._id === Store.get('boardSee')._id) {
              _self.showBoard(_self.boardFiles3[i])
            }
          }
        } else {
          if (number === 2 && _self.hashFileBoard2 !== hashFile) {
            _self.hashFileBoard2 = hashFile
            _self.parsePgnFiles(this.responseText, true, number)
            for (i = 0; i < Object.keys(_self.boardFiles2).length; i++) {
              if (_self.boardFiles2[i] !== undefined && _self.boardFiles2[i]._id === Store.get('boardSee')._id) {
                _self.showBoard(_self.boardFiles2[i])
              }
            }
          }
        }
      }
      oReq.send()
    },*/
    /* loadUserClubData (boards) {
      this.userClubData = {}
      const tableros = Object(boards)
      var _self = this
      // window.alert(JSON.stringify(tableros))
      for (var i = 0; i < Object.keys(tableros).length; i++) {
        var tablero = Object(Object.values(tableros)[i])
        var user1 = Object(tablero).u1.replace('"', '')
        var user2 = Object(tablero).u2.replace('"', '')
        _self.loadOtherUser(user1, function (someUser) {
          // userClub[user1] = someUser.club
          _self.userClubData[user1] = someUser.club
          _self.loadOtherUser(user2, function (someUser) {
            // window.alert('2')
            // userClub[user2] = someUser.club
            _self.userClubData[user2] = someUser.club
            // window.alert(JSON.stringify(_self.userClubData[user2]))
            _self.boards = boards
          })
        })
      }
    },*/
    loadAllData () {
      var data = {
        c: 'chat',
        f: 'getDataChat',
        data: {
          user: UserService.getUser()
        }
      }
      const showSocketError = (context = '') => {
        console.error('Socket desconectado error')
      }
      const maxRetries = 10
      const retryDelay = 500 // milisegundos
      let attempt = 1
      const tryEmit = () => {
        const socket = this.$socket

        if (socket && socket.connected) {
          socket.emit('event', data, (...callbacks) => {
            /* var logUser = callbacks[1].logUser
            for (var i = 0; i < logUser.length; i++) {
              if (logUser[i]) {
                // this.openTab({nickname: logUser[i]}, false)
                /* var parmsLoad = {
                  user: logUser[i],
                  range: {
                    limit: 30,
                    skip: 0
                  }
                }
                // this.loadUserConvert(parmsLoad)
              }
            }*/
            // this.loadUserClubData(callbacks[1].boards)
            this.boards = callbacks[1].boards
            console.log('USERLOGUINSOCKET:', callbacks[1])
          })
        } else {
          if (attempt <= maxRetries) {
            console.warn(`userLoguinSocket: intento ${attempt}/${maxRetries} - socket no conectado`)
            attempt++
            setTimeout(tryEmit, retryDelay)
          } else {
            showSocketError('userLoguinSocket: No se pudo conectar después de varios intentos')
          }
        }
      }

      tryEmit()
    },
    loadUserConvert (parms, historyTop = false) {
      var data = {
        c: 'chat',
        f: 'loadUserConvert',
        data: parms
      }
      const showSocketError = (context = '') => {
        console.error('Socket desconectado error')
      }
      const maxRetries = 10
      const retryDelay = 500 // milisegundos
      let attempt = 1
      const tryEmit = () => {
        const socket = this.$socket

        if (socket && socket.connected) {
          socket.emit('event', data, (...callbacks) => {
            var log = callbacks[1]
            /* if (historyTop) {
              // adiciona mensajes al principio de la conversacion
              var post = this.foundTab(this.active)
              if (log.length > 0) {
                Jquery('#content_' + this.active).animate({
                  'scrollTop': 100
                }, 'slow')
              }
              var menHistory = log.concat(this.tabs[post].men)
              this.tabs[post].men = menHistory
            } else {*/
            // Recoger todos los mensajes antiguos
            var menLast = ''
            if (log) {
              for (var i = log.length - 1; i >= 0; i--) {
                if (menLast !== log[i].body || menLast === '') {
                  this.recibeMensaje(log[i], true, false)
                  menLast = log[i].body
                }
              }
            }
            console.log('USERLOGUINSOCKET:', callbacks[1])
          })
        } else {
          if (attempt <= maxRetries) {
            console.warn(`userLoguinSocket: intento ${attempt}/${maxRetries} - socket no conectado`)
            attempt++
            setTimeout(tryEmit, retryDelay)
          } else {
            showSocketError('userLoguinSocket: No se pudo conectar después de varios intentos')
          }
        }
      }

      tryEmit()
    },
    activeWebcam () {
      this.toast('<span>No implement yet</span>', 2000)
    },
    inviteChessGame () {
      this.$broadcast('modal::open', 'inviteGame')
    },
    setSendOption (user) {
      // window.alert(JSON.stringify(user))
      if (user.sendtoanalyse) {
        user.sendtoanalyse = false
      } else {
        user.sendtoanalyse = true
      }
    },
    isBoardVisible (game) {
      // window.alert(JSON.stringify(game))
      var isYourGame = (game.u1 === this.user.username || game.u2 === this.user.username)
      var toAll = game.all === 'true' || this.user.role === 'Admin'
      var retValue = isYourGame || ((game.public === 'true' || game.broadcast === 'true') && game.club === this.user.club) || toAll
      return retValue
    },
    inviteChessGameDirectVersus () {
      // this.openTab(user)
      this.active = ''
      this.activeWhite = ''
      this.newboard.contrincante = ''
      this.userconvert = ''
      this.$broadcast('modal::open', 'inviteGameVersus')
    },
    inviteChessGameDirect (user) {
      if (this.$parent && this.$parent.userClub && this.$parent.userClub.isTournament) {
        window.swal('No puedes enviar retos mientras estás en un torneo')
        return
      }
      // this.openTab(user)
      this.active = user.nickname
      this.newboard.contrincante = ''
      this.userconvert = ''
      this.$broadcast('modal::open', 'inviteGame')
    },
    inviteChessGameDirectComputer (name, level = 0) {
      if (this.$parent && this.$parent.userClub && this.$parent.userClub.isTournament) {
        window.swal('No puedes enviar retos mientras estás en un torneo')
        return
      }
      // this.openTab(user)
      // window.alert('Invitando a jugar con ' + name + ' nivel ' + level)
      this.active = name
      this.newboard.contrincante = ''
      this.userconvert = ''
      this.newboard.elo = level
      this.$broadcast('modal::open', 'inviteGame')
    },
    isHumanVsPC () {
      return (this.boardHome !== undefined && (this.boardHome.u1 === 'PC') || (this.boardHome.u2 === 'PC'))
    },
    InviteGameActionConfirmado (invite) {
      // preparar tablero
      var data = {
        c: 'board',
        f: 'confirmGame',
        data: invite
      }
      // window.alert('InviteGameActionConfirmado' + JSON.stringify(invite))
      if (invite.confirm || invite.vsPc) {
        data.f = 'addBoard'
        // this.deleteInvite(invite)
      } else {
        // this.toast('<span>Esperando confirmacion de usuario</span>', 2000, 'rounded')
      }
      const showSocketError = (context = '') => {
        console.error('Socket desconectado error')
      }
      const maxRetries = 10
      const retryDelay = 500 // milisegundos
      let attempt = 1
      const tryEmit = () => {
        const socket = this.$socket

        if (socket && socket.connected) {
          socket.emit('event', data, (...callbacks) => {
            if (callbacks[0]) {
            // window.alert(callbacks[0])
            }
            console.log('USERLOGUINSOCKET:', callbacks[1])
          })
        } else {
          if (attempt <= maxRetries) {
            console.warn(`userLoguinSocket: intento ${attempt}/${maxRetries} - socket no conectado`)
            attempt++
            setTimeout(tryEmit, retryDelay)
          } else {
            showSocketError('userLoguinSocket: No se pudo conectar después de varios intentos')
          }
        }
      }

      tryEmit()

      // this.deleteInvite(invite)
      // eliminar invitacion del arreglo
    },
    clone (obj) {
      var dupe = (obj instanceof Array) ? [] : {}
      for (var property in obj) {
        if (typeof property === 'object') {
          dupe[property] = this.clone(obj[property])
        } else {
          dupe[property] = obj[property]
        }
      }
      return dupe
    },
    deleteInvite (invite) {
      var invites = Store.get('invitesGame', [])
      // window.alert('deleteInvite' + JSON.stringify(invite))
      var post = invites.indexOf(invite)
      // window.alert(JSON.stringify(post))
      if (post !== -1) {
        invites.splice(post, 1)
        Store.set('invitesGame', invites)
        // this.toast('<span>Eliminada correctamente</span>', 2000, 'rounded')
      } else {
        for (var i = 0; i < invites.length; i++) {
          if (invites[i].created === invite.created && invites[i].u1 === invite.u1 && invites[i].u2 === invite.u2) {
            invites.splice(post, 1)
            Store.set('invitesGame', invites)
            // this.toast('<span>Eliminada correctamente</span>', 2000, 'rounded')
          }
        }
      }
      var data = {
        c: 'board',
        f: 'refreshInviteGame',
        data: invite
      }
      const showSocketError = (context = '') => {
        console.error('Socket desconectado error')
      }
      const maxRetries = 10
      const retryDelay = 500 // milisegundos
      let attempt = 1
      const tryEmit = () => {
        const socket = this.$socket

        if (socket && socket.connected) {
          socket.emit('event', data, (...callbacks) => {
            if (callbacks[0]) {
            // window.alert(callbacks[0])
            }
            console.log('USERLOGUINSOCKET:', callbacks[1])
          })
        } else {
          if (attempt <= maxRetries) {
            console.warn(`userLoguinSocket: intento ${attempt}/${maxRetries} - socket no conectado`)
            attempt++
            setTimeout(tryEmit, retryDelay)
          } else {
            showSocketError('userLoguinSocket: No se pudo conectar después de varios intentos')
          }
        }
      }

      tryEmit()
    },
    InviteGameActionClick (invite) {
      try {
        this.deleteInvite(invite)
        const inviteForDelete = this.clone(invite)
        // preparar tablero
        // window.alert('InviteGameActionClick1' + JSON.stringify(invite))

        if (invite.u2 === '.ALL.') {
          invite.u2 = UserService.user.username
          invite.recibe = invite.u2
        }
        if (invite.u1 === '.ALL.') {
          invite.u1 = UserService.user.username
          invite.recibe = invite.u1
        }
        var data = {
          c: 'board',
          f: 'confirmGame',
          data: invite
        }
        // window.alert('InviteGameAction')
        // window.alert('InviteGameActionClick2' + JSON.stringify(inviteForDelete))

        if (invite.confirm || invite.vsPc) {
          data.f = 'addBoard'
          this.deleteInvite(inviteForDelete)
        } else {
          this.toast('<span>Esperando confirmacion de usuario</span>', 2000, 'rounded')
        }
        const showSocketError = (context = '') => {
          console.error('Socket desconectado error')
        }
        const maxRetries = 10
        const retryDelay = 500 // milisegundos
        let attempt = 1
        const tryEmit = () => {
          const socket = this.$socket

          if (socket && socket.connected) {
            socket.emit('event', data, (...callbacks) => {
              if (callbacks[0]) {
              // window.alert(callbacks[0])
              }
              console.log('USERLOGUINSOCKET:', callbacks[1])
            })
          } else {
            if (attempt <= maxRetries) {
              console.warn(`userLoguinSocket: intento ${attempt}/${maxRetries} - socket no conectado`)
              attempt++
              setTimeout(tryEmit, retryDelay)
            } else {
              showSocketError('userLoguinSocket: No se pudo conectar después de varios intentos')
            }
          }
        }

        tryEmit()
        this.deleteInvite(inviteForDelete)
        // eliminar invitacion del arreglo
        var dataInvite = {
          c: 'board',
          f: 'deleteInviteGame',
          data: inviteForDelete
        }
        attempt = 1
        const tryEmit2 = () => {
          const socket = this.$socket

          if (socket && socket.connected) {
            socket.emit('event', dataInvite, (...callbacks) => {
              if (callbacks[0]) {
              // window.alert(callbacks[0])
              }
              console.log('USERLOGUINSOCKET:', callbacks[1])
            })
          } else {
            if (attempt <= maxRetries) {
              console.warn(`userLoguinSocket: intento ${attempt}/${maxRetries} - socket no conectado`)
              attempt++
              setTimeout(tryEmit, retryDelay)
            } else {
              showSocketError('userLoguinSocket: No se pudo conectar después de varios intentos')
            }
          }
        }

        tryEmit2()
      } catch (err) {
        console.error('<span>' + 'Error (InviteGameActionClick): ' + err + '</span>', 3000)
      }
    },
    createdInviteFast (time, incremento) {
      var invites = Store.get('invitesGame', [])
      // var invitesLength = invites.length
      for (var inviteParam in invites) {
        if (invites[inviteParam].time === time && invites[inviteParam].incremento === incremento) {
          // window.alert(JSON.stringify(invites[inviteParam]))
          this.InviteGameActionClick(invites[inviteParam])
          this.toast('<span>' + 'Partida encontrada, iniciando...' + '</span>', 3000)
          return
        }
      }
      this.newboard.color = Math.random() >= 0.5 ? 'w' : 'b'
      var invite = {
        type: 'invite',
        public: 'true',
        broadcast: 'false',
        all: 'false',
        vsPc: false,
        confirm: false,
        club: UserService.getUser().club,
        time: time,
        incremento: incremento,
        recibe: this.active,
        elo: UserService.getUser().elo,
        color: this.newboard.color,
        created: new Date().getTime()
      }
      if (this.active === 'PC') {
        invite.vsPc = true
        invite.confirm = true
        // window.alert(this.newboard.elo)
        invite.elo = this.newboard.elo
      }
      var userActive = UserService.getUser().username
      // window.alert(userActive)
      // UserService.setUser(userActive)
      var bFound = false
      if (this.newboard.contrincante !== '') {
        if (this.newboard.contrincante === '-ALL-') {
          invite.confirm = false
          bFound = true
          this.active = '-ALL-'
          invite.recibe = '-ALL-'
        } else if (this.newboard.contrincante === 'PC') {
          invite.vsPc = true
          invite.elo = this.newboard.elo
          userActive = 'PC'
          // window.alert('contrincante :' + userActive)
          bFound = true
        } else {
          for (var i in this.users) {
            if (this.users[i].nickname === this.newboard.contrincante) {
              userActive = this.users[i].nickname
              invite.confirm = true
              // window.alert('contrincante :' + userActive)
              bFound = true
            }
          }
        }
        if (bFound === false) {
          // window.alert('error')
          this.$broadcast('modal::close', 'some', 'inviteGame')
          this.$broadcast('modal::close', 'some', 'inviteGameVersus')
          this.$broadcast('modal::close', 'some', 'inviteGameFast')
          return
        }
      }
      // window.alert('createdInviteGame' + JSON.stringify(invite))
      if (this.newboard.color === 'w') {
        invite.u1 = userActive
        invite.u2 = this.active
      } else {
        invite.u2 = userActive
        invite.u1 = this.active
      }
      var data = {
        c: 'board',
        f: 'inviteGame',
        data: {
          event: 'inviteGame',
          data: invite
        }
      }
      if (this.active === 'PC' || invite.confirm === true) {
        this.InviteGameActionConfirmado(invite)
      } else {
        this.toast('<span>' + Vue.t('home.inviteSend') + '</span>', 2000)
        // window.alert('send event' + JSON.stringify(data))
        const showSocketError = (context = '') => {
          console.error('Socket desconectado error')
        }
        const maxRetries = 10
        const retryDelay = 500 // milisegundos
        let attempt = 1
        const tryEmit = () => {
          const socket = this.$socket

          if (socket && socket.connected) {
            socket.emit('event', data, (...callbacks) => {
              if (callbacks[0]) {
              // window.alert(callbacks[0])
              }
              console.log('USERLOGUINSOCKET:', callbacks[1])
            })
          } else {
            if (attempt <= maxRetries) {
              console.warn(`userLoguinSocket: intento ${attempt}/${maxRetries} - socket no conectado`)
              attempt++
              setTimeout(tryEmit, retryDelay)
            } else {
              showSocketError('userLoguinSocket: No se pudo conectar después de varios intentos')
            }
          }
        }

        tryEmit()
      }
      // window.alert(JSON.stringify(invite))
      this.$broadcast('modal::close', 'some', 'inviteGameFast')
      this.$broadcast('modal::close', 'some', 'inviteGameVersus')
      this.$broadcast('modal::close', 'some', 'inviteGameFast')
      // this.loadAllData()
    },
    createdInviteGame (result) {
      if (result) {
        var invite = {
          type: 'invite',
          public: this.newboard.public,
          broadcast: 'false',
          all: 'false',
          vsPc: false,
          confirm: false,
          club: UserService.getUser().club,
          time: this.newboard.time,
          incremento: this.newboard.incremento,
          recibe: this.active,
          elo: UserService.getUser().elo,
          color: this.newboard.color,
          created: new Date().getTime()
        }
        if (this.active === 'PC') {
          invite.vsPc = true
          invite.confirm = true
          // window.alert(this.newboard.elo)
          invite.elo = this.newboard.elo
        }
        var userActive = UserService.getUser().username
        // UserService.setUser(userActive)
        var bFound = false
        // window.alert(userActive)
        if (this.newboard.contrincante !== '') {
          if (this.newboard.contrincante === '-ALL-') {
            invite.confirm = false
            bFound = true
            this.active = '-ALL-'
            invite.recibe = '-ALL-'
          } else if (this.newboard.contrincante === 'PC') {
            invite.vsPc = true
            invite.confirm = true
            invite.elo = this.newboard.elo
            userActive = 'PC'
            // window.alert('contrincante :' + userActive)
            bFound = true
          } else {
            for (var i in this.users) {
              if (this.users[i].nickname === this.newboard.contrincante) {
                userActive = this.users[i].nickname
                invite.confirm = true
                // window.alert('contrincante :' + userActive)
                bFound = true
              }
            }
          }
          if (bFound === false) {
            // window.alert('error')
            this.$broadcast('modal::close', 'some', 'inviteGame')
            this.$broadcast('modal::close', 'some', 'inviteGameVersus')
            this.$broadcast('modal::close', 'some', 'inviteGameFast')
            return
          }
        }
        // window.alert('createdInviteGame' + JSON.stringify(invite))
        if (this.newboard.color === 'w' && this.active === 'PC') {
          invite.u2 = this.active
          invite.u1 = userActive
        } else {
          invite.u1 = this.active
          invite.u2 = userActive
        }
        var data = {
          c: 'board',
          f: 'inviteGame',
          data: {
            event: 'inviteGame',
            data: invite
          }
        }
        if (this.active === 'PC' || invite.confirm === true) {
          this.InviteGameActionConfirmado(invite)
        } else {
          this.toast('<span>' + Vue.t('home.inviteSend') + '</span>', 2000)
          // window.alert('send event' + JSON.stringify(data))
          const showSocketError = (context = '') => {
            console.error('Socket desconectado error')
          }
          const maxRetries = 10
          const retryDelay = 500 // milisegundos
          let attempt = 1
          const tryEmit = () => {
            const socket = this.$socket

            if (socket && socket.connected) {
              socket.emit('event', data, (...callbacks) => {
                if (callbacks[0]) {
                // window.alert(callbacks[0])
                }
                console.log('USERLOGUINSOCKET:', callbacks[1])
              })
            } else {
              if (attempt <= maxRetries) {
                console.warn(`userLoguinSocket: intento ${attempt}/${maxRetries} - socket no conectado`)
                attempt++
                setTimeout(tryEmit, retryDelay)
              } else {
                showSocketError('userLoguinSocket: No se pudo conectar después de varios intentos')
              }
            }
          }

          tryEmit()
        }
        // window.alert(JSON.stringify(invite))
      }
      this.$broadcast('modal::close', 'some', 'inviteGame')
      this.$broadcast('modal::close', 'some', 'inviteGameVersus')
      this.$broadcast('modal::close', 'some', 'inviteGameFast')
      // this.loadAllData()
    }
  },
  ready () {
    /* let pgnvjs = document.createElement('script')
    pgnvjs.setAttribute('src', '../../../static/dist/js/pgnvjs.min.js')
    document.head.appendChild(pgnvjs)
    let simplechessboard = document.createElement('script')
    simplechessboard.setAttribute('src', '../../../static/libs/simplechessboard.min.js')
    document.head.appendChild(simplechessboard)*/
    this.classBoard = this.stylesBoard['board'][this.styles['board']] + ' chessground vuejs ' + this.stylesBoard['pieces'][this.styles['pieces']]
    // this.user = UserService.getUser()
    // window.alert(JSON.stringify(this.user))
  },
  created () {
    if (config.debug) {
      document.title = this.user.name + ' - ' + this.$t('home.title')
    } else {
      document.title = 'Mainchess - ' + this.$t('home.title')
    }
    var _self = this
    this.loadOtherUser(this.user.username, function (someUser) {
      // window.alert(someUser.username + '->' + someUser.sendtoanalyse)
      _self.sendtoteacher = someUser.sendtoanalyse
    })
    /* this.$nextTick(function () {
      const eventoLanzadoKey = 'retoLanzado'
      // Verifica si el evento ya se lanzó anteriormente
      // window.alert(localStorage.getItem(eventoLanzadoKey))
      if (localStorage.getItem(eventoLanzadoKey) === 'false') {
        // window.alert('send')
        this.sendReto('-ALL-')
        // Marca el evento como lanzado
        localStorage.setItem(eventoLanzadoKey, 'true')
      }
    }) */
   /* let pgnvjs = document.createElement('script')
    pgnvjs.setAttribute('src', '../../../static/dist/js/pgnvjs.min.js')
    document.head.appendChild(pgnvjs)
    let simplechessboard = document.createElement('script')
    simplechessboard.setAttribute('src', '../../../static/libs/simplechessboard.min.js')
    document.head.appendChild(simplechessboard)*/
    this.classBoard = this.stylesBoard['board'][this.styles['board']] + ' chessground vuejs ' + this.stylesBoard['pieces'][this.styles['pieces']]
    // this.user = UserService.getUser()
    // window.alert(JSON.stringify(this.user))
    this.$nextTick(function () {
      this.active = 'boardVisor'
      this.loadAllData()
      // window.alert(JSON.stringify(this.user))
      // window.alert(JSON.stringify(this.boards[0]))
      // this.getTorneos(1)
      // this.getTorneos(2)
    })
    this.$dispatch('userLoguin', 'show data')
    this.$nextTick(function () {
      this.showBoard()
      document.body.dispatchEvent(new window.Event('chessground.resize'))
    })
  },
  beforeDestroy () {
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?3369cf7a